import { Title } from "@mantine/core";
import classNames from "classnames";
import "./StartPageSection.scss";

interface SectionProps {
  title?: string;
  filter?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

function StartPageSection({
  title,
  filter,
  children,
  className
}: SectionProps) {
  return (
    <div className={classNames("section", className)}>
      <div className="section-header">
        {title && (
          <Title mb="2rem" order={5}>
            {title}
          </Title>
        )}
        {filter}
      </div>
      {children}
    </div>
  );
}

export { StartPageSection };
